import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
  Checkbox,
  TextField,
  Button,
  Paper,
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  CircularProgress,
  InputLabel,
  FormGroup,
  Switch,
  Chip,
  Tooltip,
  Divider,
  Stack,
} from "@mui/material";
import Sidebar from "../../Drawer/Sidebar";
import { color, flex } from "@mui/system";
import MatelRateBuyTable from "./MetalRateBuyTable";
import MetalRateSellTable from "./MetalRateSellTable";
import MetalBalanceHistoryTable from "../MetalManangement/MetalBalanceHistoryTable";
import MetalRateHistory from "./MetalRateHistory";
import {
  fetchMetals,
  getLiveRates,
} from "../../../redux/slices/metalRateSlice";
import { useDispatch, useSelector } from "react-redux";
import { addBullionRates } from "../../../redux/slices/metalRateSlice";
import { toast } from "react-toastify";
import { is } from "immutable";
import {
  getAppConfig,
  updateConfigRequest,
} from "../../../redux/Configuration/configurationSlice";
import { canShowPermission } from "../Permissions/permissionObject";
import { useTranslation } from "react-i18next";
import { getActiveCountriesRequest } from "../../../redux/CountryList/CountrySlice";
import auth from "../../../configs/auth";

const LIVE_RATE_SUPPLIERS = [
  { label: "Jewel Casa", value: "jewelcasa" },
  { label: "Star Line", value: "starline" },
];

const LIVE_RATE_METAL_ORDER = ["GOLD_999", "GOLD_995", "SILVER_999"];
const LIVE_RATE_TYPE_ORDER = { Buy: 0, Sell: 1 };

const getLiveRateTypeOrder = (rateType) => {
  if (!rateType) return 99;
  const normalized =
    String(rateType).charAt(0).toUpperCase() +
    String(rateType).slice(1).toLowerCase();
  return LIVE_RATE_TYPE_ORDER[normalized] ?? 99;
};

const sortLiveRates = (rates = []) =>
  [...rates].sort((a, b) => {
    const typeDiff = getLiveRateTypeOrder(a?.rateType) - getLiveRateTypeOrder(b?.rateType);
    if (typeDiff !== 0) return typeDiff;

    const metalA = LIVE_RATE_METAL_ORDER.indexOf(a?.liveRateName);
    const metalB = LIVE_RATE_METAL_ORDER.indexOf(b?.liveRateName);
    return (metalA === -1 ? 99 : metalA) - (metalB === -1 ? 99 : metalB);
  });

const groupLiveRatesBySupplier = (rates = []) => {
  const groups = new Map();

  rates.forEach((rate) => {
    const key = rate?.supplierName || "Live Rate";
    if (!groups.has(key)) {
      groups.set(key, []);
    }
    groups.get(key).push(rate);
  });

  return Array.from(groups.entries()).map(([groupName, groupRates]) => [
    groupName,
    sortLiveRates(groupRates),
  ]);
};

const getJewellerMetalRateType = (metalRate) => {
  if (typeof metalRate === "object" && metalRate !== null) {
    return metalRate.type || "JewellerManualRate";
  }
  return metalRate || "JewellerManualRate";
};

const normalizeSupplierName = (name) => {
  const normalized = String(name || "")
    .toLowerCase()
    .replace(/\s+/g, "");
  if (normalized === "jewelcasa") return "jewelcasa";
  if (normalized === "starline" || normalized === "startline") return "starline";
  return "";
};

const getJewellerMetalRateSupplier = (metalRate) => {
  if (typeof metalRate === "object" && metalRate !== null) {
    return normalizeSupplierName(metalRate.supplierName);
  }
  return "";
};

export default function MetalRateBuySell() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const metal = useSelector((state) => state.metalRate?.metals || []);
  const loading = useSelector((state) => state.metalRate?.loading);
  console.log("metal", metal);
  const buyRateList = useSelector(
    (state) => state.metalRate?.buyRateList || [],
  );
  const sellRateList = useSelector(
    (state) => state.metalRate?.sellRateList || [],
  );
  const bullionRates = useSelector(
    (state) => state.metalRate?.bullionRates || {},
  );
  const bullionRateMetals = useSelector(
    (state) => state.metalRate?.bullionRateMetals || [],
  );
  const states = useSelector((state) => state.metalRate?.states || []);
  // const [selectedState, setSelectedState] = useState(states[0] || "All");
  const [rateType, setRateType] = useState("buy");
  const [metals, setMetals] = useState(metal);
  const [selectAll, setSelectAll] = useState(false);
  const configData = useSelector((state) => state?.appConfig?.configData || {});
  //const [gst, setGst] = useState()
  const enabledMetals = metals.filter((m) => m.status === true);
  const disabledMetals = metals.filter((m) => m.status === false);
  console.log("enabledMetals", enabledMetals);
  console.log("disabledMetals", disabledMetals);
  const [selectedState, setSelectedState] = useState("All");
  const { activeCountries = [] } = useSelector((state) => state.country || {});
  const [selectedCountry, setSelectedCountry] = useState("");
  const [filteredStates, setFilteredStates] = useState([]);
  const getAppConfigData = useSelector((state) => state.appConfig.configData);
  const liveRatesData = useSelector(
    (state) => state.metalRate?.liveRates || [],
  );
  const [liveRates, setLiveRates] = useState(false);
  const [jewellerMetalRate, setJewellerMetalRate] =
    useState("JewellerManualRate");
  const [supplierName, setSupplierName] = useState("");
  const isLiveRateSelected = jewellerMetalRate === "JewellerLiveRate";
  const matchedSupplier = LIVE_RATE_SUPPLIERS.find(
    (supplier) =>
      supplier.value.toLowerCase() === String(supplierName || "").toLowerCase(),
  );
  const isValidSupplier = Boolean(matchedSupplier);
  const selectedSupplierValue = matchedSupplier?.value || "";
  const isSaveJewellerMetalRateDisabled =
    isLiveRateSelected && !isValidSupplier;

  const handleSaveJewellerMetalRate = () => {
    if (isLiveRateSelected && !liveRates) {
      alert("Live rate is disabled. Please contact Instalaxmi admin to enable it.");
      return;
    }
    if (isLiveRateSelected && !isValidSupplier) {
      return;
    }
    dispatch(
      updateConfigRequest({
        key: "jewellerMetalRate",
        value: isLiveRateSelected
          ? { type: "JewellerLiveRate", supplierName: selectedSupplierValue }
          : "JewellerManualRate",
      }),
    );
  };

  useEffect(() => {
    if (Object.keys(configData).length) {
      const metalRate = configData.jewellerMetalRate;
      setJewellerMetalRate(getJewellerMetalRateType(metalRate));
      setSupplierName(getJewellerMetalRateSupplier(metalRate));
    }
  }, [configData]);

  useEffect(() => {
    if (states.length) {
      setSelectedState(states[0]);
    }
  }, [states]);

  const taxType = useSelector(
    (state) => state?.appConfig?.configData?.taxtype || "GST",
  );
  console.log("From MetalRateBuySell - taxType", taxType);
  useEffect(() => {
    dispatch(getAppConfig());
  }, []);

  useEffect(() => {
    if (Object.keys(getAppConfigData).length) {
       setLiveRates(configData?.featureToggle?.Live_Rates === true);
    }
  }, [getAppConfigData]);

  useEffect(() => {
    if (!liveRates && jewellerMetalRate !== "JewellerLiveRate") return;

    let intervalId;

    const scheduleNext = () => {
      const now = new Date();

      const minutes = now.getMinutes();
      const nextMultiple = Math.ceil(minutes / 5) * 5;

      const nextTime = new Date(now);
      nextTime.setMinutes(nextMultiple);
      nextTime.setSeconds(0);
      nextTime.setMilliseconds(0);
      if (nextTime <= now) {
        nextTime.setMinutes(nextMultiple + 5);
      }

      const delay = nextTime - now;

      console.log("Next refresh at:", nextTime);

      setTimeout(() => {
        window.location.reload();
        intervalId = setInterval(
          () => {
            window.location.reload();
          },
          5 * 60 * 1000,
        );
      }, delay);
    };

    scheduleNext();

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [liveRates, dispatch]);

  useEffect(() => {
    dispatch(getLiveRates());
  }, [dispatch]);
  const handleRateChange = (index, value) => {
    let data = [];
    for (let i = 0; i < metals.length; i++) {
      let metal = metals[i];
      if (index == i) {
        if (rateType === "buy") {
          if (!metal.buyRate) metal = { ...metal, buyRate: {} };
          const baseRate = Number(value || 0);
          const cgst = metal?.cgst ?? 0;
          const sgst = metal?.sgst ?? 0;
          const GSTPercent = cgst + sgst;
          const igstPercent = metal?.igst;
          let rateWithGST = 0;
          if (taxType === "GST") {
            rateWithGST = (
              baseRate *
              (1 + parseFloat(GSTPercent) / 100)
            ).toFixed(2);
          }

          if (taxType === "VAT") {
            const cessPercent = Number(metal?.cess ?? 0);

            const taxAmount = (baseRate * igstPercent) / 100;
            const cessAmount = (taxAmount * cessPercent) / 100;

            rateWithGST = (baseRate + taxAmount + cessAmount).toFixed(2);
          }
          metal = {
            ...metal,
            isManual: true,
            buyRate: {
              ...metal.buyRate,
              ratePerGram: value,
              rateWithGST: rateWithGST,
            },
          };
        } else {
          if (!metal.sellRate) metal = { ...metal, sellRate: {} };
          metal = {
            ...metal,
            isManual: true,
            sellRate: { ...metal.sellRate, ratePerGram: value },
          };
        }
      }

      data.push({ ...metal });
    }

    setMetals(data);
  };
  console.log("metal?.cess", metal?.cess);
  console.log("metal", metal);
  const handleGSTChange = (index, value) => {
    const updated = [...metals];
    updated[index].buyRate.gst = value;
    updated[index].buyRate.rateWithGST = (
      parseFloat(updated[index].rate || 0) + parseFloat(value || 0)
    ).toString();
    setMetals(updated);
  };
  useEffect(() => {
    if (taxType !== "GST") return;

    setMetals((prev) =>
      prev.map((metal) => {
        const baseRate = Number(metal?.buyRate?.ratePerGram || 0);
        if (!baseRate) return metal;

        const cgst = Number(metal?.cgst ?? 0);
        const sgst = Number(metal?.sgst ?? 0);
        const GSTPercent = cgst + sgst;

        const rateWithGST = (baseRate * (1 + GSTPercent / 100)).toFixed(2);

        return {
          ...metal,
          buyRate: {
            ...metal.buyRate,
            rateWithGst: rateWithGST,
          },
        };
      }),
    );
  }, [
    taxType,
    metals.map((m) => m.buyRate?.ratePerGram).join(","),
    metals.map((m) => m.cgst).join(","),
    metals.map((m) => m.sgst).join(","),
  ]);

  useEffect(() => {
    if (taxType !== "VAT") return;

    setMetals((prev) =>
      prev.map((metal) => {
        const baseRate = Number(metal?.buyRate?.ratePerGram || 0);
        if (!baseRate) return metal;
        const cessPercent = Number(metal?.cess ?? 0);
        const igstPercent = metal?.igst;
        const taxAmount = (baseRate * igstPercent) / 100;
        const cessAmount = (taxAmount * cessPercent) / 100;

        const rateWithTAX = (baseRate + taxAmount + cessAmount).toFixed(2);

        return {
          ...metal,
          buyRate: {
            ...metal.buyRate,
            rateWithGst: rateWithTAX,
          },
        };
      }),
    );
  }, [
    taxType,
    metals.map((m) => m.buyRate?.ratePerGram).join(","),
    metals.map((m) => m.igst).join(","),
    metals.map((m) => m.cess).join(","),
  ]);

  const handleCheck = (index) => {
    let data = [];
    for (let i = 0; i < metals.length; i++) {
      let metal = metals[i];
      if (index == i) {
        metal = { ...metal, checked: metal.checked ? false : true };
      }
      data.push(metal);
    }
    let is_false = data.find((item) => !item.checked);
    if (is_false) {
      setSelectAll(false);
    } else {
      setSelectAll(true);
    }
    setMetals(data);
  };

  const handleSelectAll = () => {
    const newVal = selectAll ? false : true;
    setSelectAll(newVal);

    let data = metals.map((item) => {
      item = { ...item, checked: newVal };
      return item;
    });

    setMetals(data);
  };

  const getAllCountriesFromMetals = () => {
    const map = new Map();

    metals.forEach((metal) => {
      (metal.marginData || []).forEach((m) => {
        if (m.country && m.country._id) {
          map.set(m.country._id, m.country);
        }
      });
    });

    return Array.from(map.values());
  };

  const handleSubmit = () => {
    const selected = metals.filter((m) => m.checked);
    if (!selected.length) {
      return toast.info("Please select the metal");
    }

    try {
      const payload = selected.map((item) => {
        const isBuy = rateType === "buy";
        const rateObj = isBuy ? item.buyRate : item.sellRate;

        if (!rateObj || !rateObj.ratePerGram) {
          toast.info("Please fill the rate per gram for selected metals");
          throw new Error("Validation failed");
        }
        if (!item.selectedCountry) {
          toast.error(`Please select country for ${item.metalName}`);
          throw new Error("Validation failed");
        }

        if (!item.selectedStateFromMargin) {
          toast.error(`Please select state for ${item.metalName}`);
          throw new Error("Validation failed");
        }
        const baseRate = Number(rateObj.ratePerGram || 0);
        const cgst = item?.cgst ?? 0;
        const sgst = item?.sgst ?? 0;
        const GSTPercent = cgst + sgst;
        const igstPercent = item?.igst ?? 0;
        let rateWithTax;
        if (taxType === "GST") {
          rateWithTax =
            rateObj.rateWithGST ??
            (baseRate * (1 + GSTPercent / 100)).toFixed(2);
        }

        if (taxType === "VAT") {
          const cessPercent = Number(item?.cess ?? 0);

          const taxAmount = (baseRate * igstPercent) / 100;
          const cessAmount = (taxAmount * cessPercent) / 100;

          rateWithTax = (baseRate + taxAmount + cessAmount).toFixed(2);
        }
        return {
          metalName: item.metalName,
          purity: item.purity,
          isSelect: item.checked,
          ratePerGram: rateObj.ratePerGram,
          rateType: isBuy ? "Buy" : "Sell",
          state: item.selectedStateFromMargin,
          country: item.selectedCountry,
          defaultRate: !!item.defaultRate,
          ...(isBuy && {
            rateWithGst: rateWithTax,
          }),
        };
      });

      dispatch(addBullionRates(payload));
    } catch (err) {
      return;
    }
  };

  useEffect(() => {
    dispatch(fetchMetals()); // Fetch data when component mounts
  }, [dispatch]);

  const normalize = (str) => (str || "").toLowerCase().trim();

  const countryIdOf = (country) => String(country?._id || country || "");

  const sameMetal = (rate, metal) => {
    const bullion = rate?.bullion;
    if (!bullion || typeof bullion !== "object") return false;
    return (
      normalize(bullion.metalName) === normalize(metal.metalName) &&
      String(bullion.purity) === String(metal.purity) &&
      String(bullion.karat) === String(metal.karat)
    );
  };

  const ratesForMetal = (list, embedded, metal) => {
    const matched = (Array.isArray(list) ? list : []).filter((rate) =>
      sameMetal(rate, metal),
    );
    if (matched.length) return matched;
    return Array.isArray(embedded) ? embedded : [];
  };

  const pickStateRate = (rates, selected) => {
    const forState = rates.find((r) => normalize(r.state) === selected);
    if (forState) return forState;
    return rates.find((r) => normalize(r.state) === "all");
  };

  const getStateWiseRate = (rates = [], selectedState, countryId) => {
    if (!Array.isArray(rates) || !rates.length) return {};

    const selected = normalize(selectedState);
    const country = String(countryId || "");
    if (!country) return pickStateRate(rates, selected) || {};

    const forCountry = rates.filter(
      (rate) => countryIdOf(rate.country) === country,
    );
    const matched = pickStateRate(forCountry, selected);
    if (matched) return matched;

    // Rates saved before country was stored have no country. The card is
    // already scoped by the bullion margin country, so use that rate.
    const unscoped = rates.filter((rate) => !countryIdOf(rate.country));
    return pickStateRate(unscoped, selected) || {};
  };
  const [permissions, setPermissions] = useState({});
  useEffect(() => {
    const storedPermissions = localStorage.getItem("userPermissions");
    if (storedPermissions) {
      try {
        setPermissions(JSON.parse(storedPermissions));
      } catch (error) {
        console.error("Error parsing stored permissions", error);
      }
    }
  }, []);
  const canCreateMetalRate = canShowPermission(
    permissions,
    "metalPriceHistory",
    "create",
  );
  const canViewJeweller = canShowPermission(permissions, "jeweller", "view");

  const handleCountryChange = (index, countryId) => {
    setMetals((prev) =>
      prev.map((m, i) => {
        if (i !== index) return m;

        let statesArr = [];

        (m.marginData || []).forEach((md) => {
          if (md.country?._id === countryId) {
            statesArr =
              md.stateDetails
                ?.filter((s) => normalize(s.rateType) === normalize(rateType))
                ?.map((s) => s.state) || [];
          }
        });

        return {
          ...m,
          selectedCountry: countryId,
          filteredStates: statesArr,
          selectedStateFromMargin: statesArr[0] || "",
          isManual: false,
        };
      }),
    );
  };

  const handleStateChange = (index, state) => {
    setMetals((prev) =>
      prev.map((m, i) =>
        i === index
          ? { ...m, selectedStateFromMargin: state, isManual: false }
          : m,
      ),
    );
  };

  const handleDefaultRateChange = (index, checked) => {
    setMetals((prev) =>
      prev.map((m, i) => {
        if (i !== index) return m;
        const isBuy = rateType === "buy";
        return {
          ...m,
          isManual: true,
          defaultRate: checked,
          buyRate: isBuy ? { ...m.buyRate, defaultRate: checked } : m.buyRate,
          sellRate: !isBuy
            ? { ...m.sellRate, defaultRate: checked }
            : m.sellRate,
        };
      }),
    );
  };

  const metalCardSx = {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    p: 2,
    borderRadius: 2.5,
    border: "1px solid",
    borderColor: "divider",
    background: "linear-gradient(180deg, #ffffff 0%, #fafafa 100%)",
    boxShadow: "0 4px 14px rgba(15, 23, 42, 0.06)",
    transition: "box-shadow 0.2s ease, transform 0.2s ease",
    "&:hover": {
      boxShadow: "0 8px 22px rgba(15, 23, 42, 0.1)",
      transform: "translateY(-1px)",
    },
  };

  const renderDefaultRateControl = (metal, index) => (
    <Box
      sx={{
        mb: 2,
        px: 1.5,
        py: 1,
        borderRadius: 2,
        border: "1px solid",
        borderColor: metal.defaultRate ? "#c7d2fe" : "#e5e7eb",
        backgroundColor: metal.defaultRate ? "#eef2ff" : "#f9fafb",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={1}
      >
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography
              variant="body2"
              sx={{ fontWeight: 700, color: "#111827", lineHeight: 1.2 }}
            >
              Default rate
            </Typography>
            {metal.defaultRate && (
              <Chip
                size="small"
                label="Active"
                color="primary"
                sx={{ height: 20, fontSize: 11, fontWeight: 600 }}
              />
            )}
          </Stack>
          <Typography
            variant="caption"
            sx={{
              display: "block",
              color: "#6b7280",
              mt: 0.5,
              lineHeight: 1.35,
            }}
          >
            Used when customer country has no rate
          </Typography>
        </Box>
        <Tooltip title="Fallback rate for customers whose country has no matching bullion rate">
          <Switch
            size="small"
            color="primary"
            checked={!!metal.defaultRate}
            onChange={(e) =>
              handleDefaultRateChange(index, e.target.checked)
            }
          />
        </Tooltip>
      </Stack>
    </Box>
  );

  const renderMetalHeader = (metal, index) => (
    <>
      <Stack
        direction="row"
        alignItems="flex-start"
        justifyContent="space-between"
        spacing={1}
        sx={{ mb: 1.5 }}
      >
        <FormControlLabel
          sx={{
            m: 0,
            alignItems: "flex-start",
            "& .MuiFormControlLabel-label": {
              fontSize: 13,
              color: "#4b5563",
              pt: 0.5,
            },
          }}
          control={
            <Checkbox
              size="small"
              checked={!!metal.checked}
              onChange={() => handleCheck(index)}
              sx={{ pt: 0.25 }}
            />
          }
          label="Include in save"
        />
        <Chip
          size="small"
          label={metal.status ? "Enabled" : "Disabled"}
          sx={{
            fontWeight: 600,
            bgcolor: metal.status ? "#dcfce7" : "#fee2e2",
            color: metal.status ? "#166534" : "#991b1b",
          }}
        />
      </Stack>

      <Box
        sx={{
          mb: 2,
          px: 1.5,
          py: 1.25,
          borderRadius: 2,
          background:
            rateType === "buy"
              ? "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)"
              : "linear-gradient(135deg, #0f766e 0%, #0d9488 100%)",
          color: "#fff",
          boxShadow:
            rateType === "buy"
              ? "0 8px 18px rgba(79, 70, 229, 0.25)"
              : "0 8px 18px rgba(13, 148, 136, 0.25)",
        }}
      >
        <Typography sx={{ fontWeight: 700, fontSize: 15, lineHeight: 1.3 }}>
          {metal.metalName} · {metal.karat}k · {metal.purity}
        </Typography>
        <Typography sx={{ fontSize: 12, opacity: 0.9, mt: 0.25 }}>
          {rateType === "buy" ? "Buy rate" : "Sell rate"}
        </Typography>
      </Box>
    </>
  );

  const renderBuyFields = (list) => (
    <Grid container spacing={2.5} mt={0.5}>
      {list.map((metal) => {
        const index = metals.findIndex((m) => m.id === metal.id);
        return (
          <Grid
            key={metal.id}
            size={{ xs: 12, sm: 6, md: 4 }}
            sx={{ display: "flex" }}
          >
            <Box sx={{ ...metalCardSx, width: "100%" }}>
              {renderMetalHeader(metal, index)}

              <FormControl fullWidth size="small" sx={{ mb: 1.5 }}>
                <InputLabel>Country</InputLabel>
                <Select
                  value={metal.selectedCountry || ""}
                  label="Country"
                  onChange={(e) => handleCountryChange(index, e.target.value)}
                >
                  {(metal.marginData || []).map((m) => (
                    <MenuItem key={m.country?._id} value={m.country?._id}>
                      {m.country?.countryName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth size="small" sx={{ mb: 1.5 }}>
                <InputLabel>State</InputLabel>
                <Select
                  value={metal.selectedStateFromMargin || ""}
                  label="State"
                  onChange={(e) => handleStateChange(index, e.target.value)}
                >
                  {(metal.filteredStates || []).map((state, i) => (
                    <MenuItem key={i} value={state}>
                      {state}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {renderDefaultRateControl(metal, index)}

              <Divider sx={{ mb: 1.5 }} />

              <TextField
                fullWidth
                required
                label={t("metalRates.ratePerGram")}
                type="number"
                inputProps={{ min: 0 }}
                variant="outlined"
                size="small"
                value={metal?.buyRate?.ratePerGram ?? 0}
                onChange={(e) => handleRateChange(index, e.target.value)}
                sx={{ mb: 1.5 }}
              />
              {taxType === "GST" && (
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    mb: 1,
                  }}
                >
                  <TextField
                    fullWidth
                    label={t("metalRates.cgstPercent")}
                    // variant="filled"
                    disabled
                    size="small"
                    value={metal?.cgst ?? 0}
                    onChange={(e) => handleGSTChange(index, e.target.value)}
                    sx={{ mb: 1 }}
                  />

                  <TextField
                    fullWidth
                    label={t("metalRates.sgstPercent")}
                    // variant="filled"
                    disabled
                    size="small"
                    value={metal?.sgst ?? 0}
                    onChange={(e) => handleGSTChange(index, e.target.value)}
                    sx={{ mb: 1 }}
                  />

                  <TextField
                    fullWidth
                    label={t("metalRates.igstPercent")}
                    // variant="filled"
                    disabled
                    size="small"
                    value={metal?.igst ?? 0}
                    onChange={(e) => handleGSTChange(index, e.target.value)}
                    sx={{ mb: 1 }}
                  />
                </Box>
              )}
              {taxType === "VAT" && (
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    mb: 1,
                  }}
                >
                  <TextField
                    fullWidth
                    label={t("metalRates.taxPercent")}
                    // variant="filled"
                    disabled
                    size="small"
                    value={metal?.igst ?? 0}
                    onChange={(e) => handleGSTChange(index, e.target.value)}
                    sx={{ mb: 1 }}
                  />

                  {metal?.cess !== undefined && (
                    <TextField
                      fullWidth
                      label={t("metalRates.cessPercent")}
                      disabled
                      size="small"
                      value={metal?.cess ?? 0}
                      sx={{ mb: 1 }}
                    />
                  )}
                </Box>
              )}
              <Box sx={{ display: "flex", gap: 1, mt: "auto" }}>
                <TextField
                  fullWidth
                  label={
                    taxType === "VAT"
                      ? t("metalRates.rateWithTax")
                      : t("metalRates.rateWithGstCgstSgst")
                  }
                  variant="outlined"
                  size="small"
                  value={metal?.buyRate?.rateWithGst ?? ""}
                  disabled
                />
                {taxType === "GST" && (
                  <TextField
                    fullWidth
                    label={t("metalRates.rateWithGstIgst")}
                    variant="outlined"
                    size="small"
                    value={
                      metal?.buyRate?.ratePerGram && metal?.igst
                        ? (
                            Number(metal.buyRate.ratePerGram) *
                            (1 + Number(metal.igst) / 100)
                          ).toFixed(2)
                        : ""
                    }
                    disabled
                  />
                )}
              </Box>
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );

  const renderSellFields = (list) => (
    <Grid container spacing={2.5} mt={0.5}>
      {list.map((metal) => {
        const index = metals.findIndex((m) => m.id === metal.id);
        return (
          <Grid
            key={metal._id || metal.id}
            size={{ xs: 12, sm: 6, md: 4 }}
            sx={{ display: "flex" }}
          >
            <Box sx={{ ...metalCardSx, width: "100%" }}>
              {renderMetalHeader(metal, index)}

              <FormControl fullWidth size="small" sx={{ mb: 1.5 }}>
                <InputLabel>Country</InputLabel>
                <Select
                  value={metal.selectedCountry || ""}
                  label="Country"
                  onChange={(e) => handleCountryChange(index, e.target.value)}
                >
                  {(metal.marginData || []).map((m) => (
                    <MenuItem key={m.country?._id} value={m.country?._id}>
                      {m.country?.countryName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth size="small" sx={{ mb: 1.5 }}>
                <InputLabel>State</InputLabel>
                <Select
                  value={metal.selectedStateFromMargin || ""}
                  label="State"
                  onChange={(e) => handleStateChange(index, e.target.value)}
                >
                  {(metal.filteredStates || []).map((state, i) => (
                    <MenuItem key={i} value={state}>
                      {state}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {renderDefaultRateControl(metal, index)}

              <Divider sx={{ mb: 1.5 }} />

              <TextField
                fullWidth
                required
                label={t("metalRates.ratePerGram")}
                type="number"
                inputProps={{ min: 0 }}
                variant="outlined"
                size="small"
                value={metal?.sellRate?.ratePerGram ?? 0}
                onChange={(e) => handleRateChange(index, e.target.value)}
                sx={{ mb: 2, mt: "auto" }}
              />
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );

  useEffect(() => {
    if (!metals.length) return;
    const hasRates = metals.every((m) => Array.isArray(m.currentbuyrate));
    if (!hasRates) return;
    const ready = metals.every((m) => m.selectedStateFromMargin !== undefined);
    if (!ready) return;

    const updatedMetals = metals.map((m) => {
      const selected = m.selectedStateFromMargin || "All";
      const buyRates = ratesForMetal(buyRateList, m.currentbuyrate, m);
      const sellRates = ratesForMetal(sellRateList, m.currentsellrate, m);

      const buyRate = getStateWiseRate(buyRates, selected, m.selectedCountry);
      const sellRate = getStateWiseRate(
        sellRates,
        selected,
        m.selectedCountry,
      );
      const serverDefaultRate = !!(
        (rateType === "buy" ? buyRate : sellRate)?.defaultRate
      );

      // Keep typed gram rates, but always copy defaultRate from the
      // selected country/state so the switch updates after save/refetch.
      if (m.isManual) {
        return {
          ...m,
          defaultRate: serverDefaultRate,
          buyRate: m.buyRate
            ? { ...m.buyRate, defaultRate: !!buyRate?.defaultRate }
            : m.buyRate,
          sellRate: m.sellRate
            ? { ...m.sellRate, defaultRate: !!sellRate?.defaultRate }
            : m.sellRate,
        };
      }

      return {
        ...m,
        buyRate: buyRate || {},
        sellRate: sellRate || {},
        defaultRate: serverDefaultRate,
      };
    });

    setMetals(updatedMetals);
  }, [
    selectedState,
    rateType,
    buyRateList,
    sellRateList,
    metals
      .map(
        (m) =>
          `${m.selectedCountry || ""}:${m.selectedStateFromMargin || ""}`,
      )
      .join("|"),
  ]);
  useEffect(() => {
    setMetals((prev) =>
      prev.map((m) => ({
        ...m,
        isManual: false,
      })),
    );
  }, [selectedState]);

  useEffect(() => {
    if (!metal.length) return;

    setMetals((prev) =>
      metal.map((m, index) => {
        const prevMetal =
          prev.find(
            (p) =>
              normalize(p.metalName) === normalize(m.metalName) &&
              String(p.purity) === String(m.purity),
          ) || prev[index];

        const firstCountry = m.marginData?.[0]?.country?._id;
        const selectedCountry =
          prevMetal?.selectedCountry || firstCountry || "";

        let statesArr = [];
        (m.marginData || []).forEach((md) => {
          if (String(md.country?._id) === String(selectedCountry)) {
            statesArr =
              md.stateDetails
                ?.filter((s) => normalize(s.rateType) === normalize(rateType))
                ?.map((s) => s.state) || [];
          }
        });
        if (!statesArr.length && m.marginData?.length) {
          statesArr =
            m.marginData[0]?.stateDetails
              ?.filter((s) => normalize(s.rateType) === normalize(rateType))
              ?.map((s) => s.state) || [];
        }

        const selectedStateFromMargin = statesArr.includes(
          prevMetal?.selectedStateFromMargin,
        )
          ? prevMetal.selectedStateFromMargin
          : statesArr.includes("All")
            ? "All"
            : statesArr[0] || "";

        const buyRates = ratesForMetal(buyRateList, m.currentbuyrate, m);
        const sellRates = ratesForMetal(sellRateList, m.currentsellrate, m);
        const buyRate = getStateWiseRate(
          buyRates,
          selectedStateFromMargin,
          selectedCountry,
        );
        const sellRate = getStateWiseRate(
          sellRates,
          selectedStateFromMargin,
          selectedCountry,
        );

        return {
          ...m,
          selectedCountry,
          filteredStates: statesArr,
          selectedStateFromMargin,
          buyRate: buyRate || {},
          sellRate: sellRate || {},
          defaultRate: !!(
            (rateType === "buy" ? buyRate : sellRate)?.defaultRate
          ),
          isManual: false,
          checked: prevMetal?.checked,
        };
      }),
    );
  }, [metal, rateType, buyRateList, sellRateList]);

  useEffect(() => {
    setMetals((prev) =>
      prev.map((m) => {
        let statesArr = [];

        (m.marginData || []).forEach((md) => {
          if (md.country?._id === m.selectedCountry) {
            statesArr =
              md.stateDetails
                ?.filter((s) => normalize(s.rateType) === normalize(rateType))
                ?.map((s) => s.state) || [];
          }
        });

        return {
          ...m,
          filteredStates: statesArr,
          selectedStateFromMargin: statesArr.includes(m.selectedStateFromMargin)
            ? m.selectedStateFromMargin
            : statesArr[0] || "",
        };
      }),
    );
  }, [rateType, metals.map((m) => m.selectedCountry).join(",")]);

  const liveRateGroups = groupLiveRatesBySupplier(
    Array.isArray(liveRatesData) ? liveRatesData : [],
  );
  const showLiveRateGroupHeadings = liveRateGroups.length > 1;

  return (
    <Box sx={{ width: "98%" }}>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          mt: 0,
          mb: { xs: 5, md: 5 },
        }}
      >
        <Paper
          elevation={2}
          sx={{
            width: "100%",
            borderRadius: 2,
            overflow: "hidden",
            marginBottom: 2,
            marginTop: 2,
          }}
        >
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            sx={{
              background: "#e8f5e9",
              px: 3,
              py: 1.5,
            }}
          >
            {/* CENTER CHECKBOXES */}
            <Grid
              item
              xs
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 3,
                flexWrap: "wrap",
              }}
            >
              <FormGroup
                row
                sx={{
                  gap: 6,
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isLiveRateSelected}
                      onChange={() => {
                        if (isLiveRateSelected) return;
                        if (!liveRates) {
                          alert("Live rate is disabled. Please contact Instalaxmi admin to enable it.");
                          return;
                        }
                        setJewellerMetalRate("JewellerLiveRate");
                        if (!canViewJeweller) {
                          setSupplierName((prev) => prev || "jewelcasa");
                        }
                      }}
                      sx={{
                        color: "#2e7d32",
                        "&.Mui-checked": { color: "#2e7d32" },
                      }}
                    />
                  }
                  label={
                    <Typography fontWeight={600} color="#1b5e20">
                      Live Rate
                    </Typography>
                  }
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={jewellerMetalRate === "JewellerManualRate"}
                      onChange={() =>
                        setJewellerMetalRate("JewellerManualRate")
                      }
                      sx={{
                        color: "#2e7d32",
                        "&.Mui-checked": { color: "#2e7d32" },
                      }}
                    />
                  }
                  label={
                    <Typography fontWeight={600} color="#1b5e20">
                      Manual Rate
                    </Typography>
                  }
                />
              </FormGroup>

              {isLiveRateSelected && canViewJeweller && (
                <FormControl
                  size="small"
                  required
                  error={!isValidSupplier}
                  sx={{ minWidth: 200 }}
                >
                  <InputLabel id="live-rate-supplier-label">
                    Select Supplier
                  </InputLabel>
                  <Select
                    labelId="live-rate-supplier-label"
                    value={selectedSupplierValue}
                    label="Select Supplier"
                    onChange={(e) => setSupplierName(e.target.value)}
                  >
                    {LIVE_RATE_SUPPLIERS.map((supplier) => (
                      <MenuItem key={supplier.value} value={supplier.value}>
                        {supplier.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            </Grid>

            {/* RIGHT SIDE BUTTON */}
            <Grid item>
              <Button
                variant="contained"
                onClick={handleSaveJewellerMetalRate}
                disabled={isSaveJewellerMetalRateDisabled}
                sx={{
                  bgcolor: "#7A3FFF",
                  px: 5,
                  height: "40px",
                  borderRadius: "10px",
                  textTransform: "none",
                  fontWeight: 600,
                  boxShadow: "0 4px 12px rgba(122,63,255,0.3)",
                  "&:hover": {
                    bgcolor: "#5f2bd8",
                  },
                  "&.Mui-disabled": {
                    bgcolor: "#c5b3f5",
                    color: "#fff",
                  },
                }}
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </Paper>

        {liveRates && isLiveRateSelected && (
          <Box mb={3}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                mb: 2,
                color: "#0d47a1",
              }}
            >
              Current Live Rate
            </Typography>

            {liveRateGroups.map(([groupName, rates]) => (
              <Box key={groupName} mb={showLiveRateGroupHeadings ? 2 : 0}>
                {showLiveRateGroupHeadings && (
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 700,
                      mb: 1,
                      color: "#0d47a1",
                    }}
                  >
                    {groupName}
                  </Typography>
                )}
                <Grid container spacing={2}>
                  {rates.map((rate, index) => (
                    <Grid
                      item
                      xs={12}
                      md={4}
                      key={`${groupName}-${rate?.liveRateName}-${rate?.rateType}-${index}`}
                      sx={{ display: "flex" }}
                    >
                      <Box
                        sx={{
                          flex: 1,
                          p: 2,
                          borderRadius: 2,
                          background: "#e3f2fd",
                          boxShadow: 2,
                          textAlign: "center",
                          width: "370px",
                          height: "100%",
                        }}
                      >
                        <Typography fontWeight={600} color="#0d47a1">
                          {rate?.liveRateName || "N/A"}
                        </Typography>
                        {rate?.rateType && (
                          <Typography
                            variant="body2"
                            fontWeight={600}
                            color="#1565c0"
                          >
                            {rate.rateType}
                          </Typography>
                        )}
                        {rate?.supplierName && !showLiveRateGroupHeadings && (
                          <Typography variant="body2" color="text.secondary">
                            {rate.supplierName}
                          </Typography>
                        )}

                        <Typography variant="h6" fontWeight={700}>
                          ₹ {rate?.ratePerGram ?? 0}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            ))}
          </Box>
        )}
        <Paper sx={{ p: 4, width: "100%" }}>
          <Typography variant="h5" fontWeight={700} mb={3}>
            {t("metalRates.enabledMetalRates")}
          </Typography>
          <FormControl component="fieldset">
            <FormLabel component="legend">
              {t("metalRates.selectRateType")}
            </FormLabel>
            <RadioGroup
              row
              value={rateType}
              onChange={(e) => {
                setRateType(e.target.value);
                // Reset GST and rateWithGST if switching to Sell
                if (e.target.value === "sell") {
                  setMetals((prev) =>
                    prev.map((m) => ({ ...m, gst: "", rateWithGST: "" })),
                  );
                }
              }}
            >
              <FormControlLabel
                value="buy"
                control={<Radio />}
                label={t("metalRates.buy")}
              />
              <FormControlLabel
                value="sell"
                control={<Radio />}
                label={t("metalRates.sell")}
              />
            </RadioGroup>
          </FormControl>

          <Box mt={3}>
            <FormControlLabel
              control={
                <Checkbox checked={selectAll} onChange={handleSelectAll} />
              }
              label={t("metalRates.selectAll")}
            />
          </Box>

          <Box mt={2}>
            {loading ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="200px"
              >
                <CircularProgress size={23} />
                <p style={{ marginLeft: "10px" }}>{t("metalRates.loading")}</p>
              </Box>
            ) : (
              <>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: 1.5,
                    mb: 2,
                    px: 2,
                    py: 1.5,
                    borderRadius: 2,
                    background:
                      "linear-gradient(135deg, #ecfdf5 0%, #f0fdf4 100%)",
                    border: "1px solid #bbf7d0",
                  }}
                >
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        color: "#166534",
                        fontWeight: 800,
                        letterSpacing: 0.2,
                        lineHeight: 1.2,
                      }}
                    >
                      Enabled Metals
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#4b5563", mt: 0.5 }}>
                      {enabledMetals.length} metal
                      {enabledMetals.length === 1 ? "" : "s"} ready for rate update
                    </Typography>
                  </Box>
                  <Chip
                    label={`${enabledMetals.length} Active`}
                    sx={{
                      fontWeight: 700,
                      bgcolor: "#16a34a",
                      color: "#fff",
                    }}
                  />
                </Box>

                <Box
                  sx={{
                    background: "#fff7ed",
                    border: "1px solid #fed7aa",
                    borderRadius: 2,
                    px: 2,
                    py: 1.25,
                    mb: 2.5,
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{ color: "#9a3412", fontWeight: 500 }}
                  >
                    {t("metalRates.noteRateLimit")}
                  </Typography>
                </Box>

                {rateType === "buy"
                  ? renderBuyFields(enabledMetals)
                  : renderSellFields(enabledMetals)}

                {/* Disabled Metals */}
                {disabledMetals.length > 0 && (
                  <>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                        gap: 1.5,
                        mt: 4,
                        mb: 2,
                        px: 2,
                        py: 1.5,
                        borderRadius: 2,
                        background:
                          "linear-gradient(135deg, #fef2f2 0%, #fff1f2 100%)",
                        border: "1px solid #fecaca",
                      }}
                    >
                      <Box>
                        <Typography
                          variant="h6"
                          sx={{
                            color: "#991b1b",
                            fontWeight: 800,
                            letterSpacing: 0.2,
                            lineHeight: 1.2,
                          }}
                        >
                          Disabled Metals
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ color: "#6b7280", mt: 0.5 }}
                        >
                          {disabledMetals.length} metal
                          {disabledMetals.length === 1 ? "" : "s"} currently inactive
                        </Typography>
                      </Box>
                      <Chip
                        label={`${disabledMetals.length} Inactive`}
                        sx={{
                          fontWeight: 700,
                          bgcolor: "#dc2626",
                          color: "#fff",
                        }}
                      />
                    </Box>

                    {rateType === "buy"
                      ? renderBuyFields(disabledMetals)
                      : renderSellFields(disabledMetals)}
                  </>
                )}
              </>
            )}
          </Box>

          <Box display="flex" justifyContent="flex-end" mt={4}>
            {canCreateMetalRate && (
              <Button
                variant="contained"
                onClick={handleSubmit}
                sx={{ backgroundColor: "#7A3FFF" }}
              >
                {t("metalRates.add")}
              </Button>
            )}
          </Box>
        </Paper>
        <Box sx={{ width: "100%", mt: 3 }}>
          <MatelRateBuyTable title={t("metalRates.currentBuyMetalRates")} />
        </Box>

        <Box sx={{ width: "100%", mt: 3 }}>
          <MetalRateSellTable title={t("metalRates.currentSellMetalRates")} />
        </Box>

        {bullionRateMetals.map((item) => {
          return (
            <Box sx={{ width: "100%", mt: 3 }} key={item._id}>
              <MetalRateHistory
                title={`${t("metalRates.metalRatesHistory")} ${item.key}`}
                bullionId={item._id}
                initialList={bullionRates[item.key]}
              />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
